import { render, staticRenderFns } from "./FooterTopArea.vue?vue&type=template&id=14bc0b60&"
import script from "./FooterTopArea.vue?vue&type=script&lang=js&"
export * from "./FooterTopArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports